// extracted by mini-css-extract-plugin
export default {"footer":"h1UqX"};